import { render } from "./AppValidationError.vue?vue&type=template&id=30cc8011"
import script from "./AppValidationError.vue?vue&type=script&lang=js"
export * from "./AppValidationError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__